import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function BillingCallback() {
    const [params] = useSearchParams();
    const ref = params.get("reference") || params.get("trxref") || "";
    const [state, setState] = useState({ phase: "checking", msg: "" });

    useEffect(() => {
        if (!ref) { setState({ phase: "failed", msg: "Missing payment reference" }); return; }
        api.get(`/billing/paystack/verify/${encodeURIComponent(ref)}`)
            .then(({ data }) => setState(data.status === "paid"
                ? { phase: "paid", msg: `Your plan is active until ${new Date(data.paid_until).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}.` }
                : { phase: "failed", msg: "Payment was not completed." }))
            .catch((e) => setState({ phase: "failed", msg: formatApiError(e.response?.data?.detail) || "Could not confirm payment" }));
    }, [ref]);

    const Icon = state.phase === "paid" ? CheckCircle2 : state.phase === "failed" ? XCircle : Loader2;
    return (
        <div className="p-6 sm:p-12 max-w-lg" data-testid="billing-callback-page">
            <div className="bg-white border border-ink/10 p-8">
                <Icon className={`w-10 h-10 ${state.phase === "paid" ? "text-emerald-600" : state.phase === "failed" ? "text-red-600" : "text-klein animate-spin"}`} />
                <h1 className="mt-4 font-display font-extrabold text-3xl text-ink" data-testid="billing-callback-title">
                    {state.phase === "paid" ? "Payment received" : state.phase === "failed" ? "Payment not confirmed" : "Confirming payment…"}
                </h1>
                <p className="mt-2 text-sm text-ink/60" data-testid="billing-callback-msg">{state.msg}</p>
                {state.phase !== "checking" && (
                    <button onClick={() => { window.location.href = state.phase === "paid" ? "/dashboard" : "/billing"; }}
                        className="mt-6 bg-klein text-white px-5 py-3 text-sm" data-testid="billing-callback-continue">
                        {state.phase === "paid" ? "Go to dashboard" : "Back to billing"}
                    </button>
                )}
                <div className="mt-3"><Link to="/billing" className="text-sm text-klein">Billing page</Link></div>
            </div>
        </div>
    );
}
